<template>
  <div
    ref="productCarousel"
    v-html="carousel"
    class="product-carousel-container r-product-carousel-legacy"
  ></div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "ProductCarousel",
  data() {
    return {
      translations: window.vue.translations,
      addedTimer: null,
    };
  },
  created() {},
  computed: {
    ...mapState(["svgPath"]),
    ...mapGetters({
      carousel: "carousel",
    }),
  },
  methods: {
    scrollToTheTopOfTheCart() {
      let element = document.getElementById("app");
      let elementPosition = element.getBoundingClientRect().top;

      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    },
  },

  mounted() {
    let explicitCarousels = document.querySelectorAll('.r-carousel');
    if (explicitCarousels.length > 0) {
      explicitCarousels.forEach(el => {
        document.dispatchEvent(
            new CustomEvent('ProductCarouselLoaded', {
              detail: {
                node: el
              }
            }
          )
        );
      });
    } else {
      document.dispatchEvent(
          new CustomEvent('ProductCarouselLoaded', {
            detail: {
              node: this.$refs.productCarousel.querySelector(
                `[data-template='recommenders/recommendationscarousel']`
              )
            }
          }
        )
      );
    }

    document.addEventListener("update-cart-carousel-added-button", (event) => {
      let closestButton = event.detail.target.closest("button");
      closestButton.innerHTML = `
      <svg class="checked-new">
                  <use href="${this.svgPath}#checked-new" />
      </svg>
      <span class="added-text"> ${this.translations["label.added"]}</span>
      `;

      setTimeout(() => {
        closestButton
          ? (closestButton.innerHTML = `
        <span> ${this.translations["button.addtocart"]}</span>`)
          : null;
      }, 5000);
    });
  },
};
</script>

<style >
</style>
